import { createContext } from "react";

export const WatchContext = createContext();